import $ from "jquery";
import {UserInputSliderSelector} from "./UserInputSliderSelector";

export class UserInputOptionSelector extends UserInputSliderSelector {

  constructor(target) {
    super(target);

    this.$sliderTrack = this.$widget.find(".user-input-option-selector");
    this.$items = this.$sliderTrack.find("ul.options li");
    this.$labelItems = this.$sliderTrack.find("ul.options-labels li");

    // Get CSS variable values
    this.minValue = parseInt(this.$sliderTrack.css("--user-input-min"));
    this.maxValue = parseInt(this.$sliderTrack.css("--user-input-max"));
    this.currentValue = parseInt(this.$sliderTrack.css("--user-input-current"));
    this.initialValue = parseInt(this.$sliderTrack.css("--user-input-initial"));

    this.currentRealValue = this.getRealValue();

    this.init();
  }

  getUnitConversion() {
    const conversion = app.getTemperatureUnitConversion();
    if (!conversion) return null;

    // Only run if at least one option label uses the unit we'd convert from (e.g. "65°F").
    // Skips selectors already in the preferred unit and ones with non-temperature labels.
    const $spans = this.$widget.find("ul.options-labels li .i18n span");
    const hasMatchingUnit = $spans.toArray().some((el) => $(el).text().trim().endsWith(conversion.from));
    return hasMatchingUnit ? conversion : null;
  }

  init() {
    super.init();

    if (this.unitConversion) {
      this.$labelItems.find(".i18n span").each((i, el) => {
        const $el = $(el);
        const match = $el.text().trim().match(/^(-?\d+(?:\.\d+)?)(°[FC])$/);
        if (!match || match[2] !== this.unitConversion.from) return;
        $el.text(`${Math.round(this.unitConversion.convert(parseFloat(match[1])))}${this.unitConversion.unit}`);
      });
    }

    // Start dragging when the user presses the handle
    this.$dragHandle.off("mousedown.optionSelector touchstart.optionSelector")
      .on("mousedown.optionSelector touchstart.optionSelector", (e) => {
        const touchPoint = e.originalEvent.touches ? e.originalEvent.touches[0] : null;
        const pointerX = touchPoint ? touchPoint.pageX : e.pageX;

        // Offset, handle can be drag from anywhere within it
        this.dragHandleOffset = pointerX - this.$dragHandle.offset().left;
      });

    this.$items.off("click").on("click", (e) => {
      const value = $(e.currentTarget).index() + this.minValue;
      this.updateVisually(value);
      this.valueChange(value);
    });

    this.updateVisually(this.currentValue);
  }

  updateFromPointer(pointerX) {
    const sliderOffset = this.$sliderTrack.offset();
    if (!sliderOffset) return;

    const sliderLeftEdge = sliderOffset.left;
    const sliderWidth = this.$sliderTrack.outerWidth();

    const segmentCount = this.maxValue - this.minValue + 1;
    const segmentWidth = sliderWidth / segmentCount;
    const usableWidth = sliderWidth - segmentWidth;

    // Adjust pointer by where within the handle the user grabbed,
    // then shift to the center of the handle so snapping feels natural
    const adjustedX = pointerX - sliderLeftEdge - this.dragHandleOffset + segmentWidth / 2;

    // While dragging, move freely with the cursor
    if (this.isDragging) {
      const clamped = Math.max(0, Math.min(usableWidth, adjustedX - segmentWidth / 2));
      const progress = clamped / usableWidth;
      this.$sliderTrack.css("--progress", progress);
      return;
    }

    // SNAP LOGIC — use the adjusted center position
    let index = Math.floor(adjustedX / segmentWidth);
    index = Math.max(0, Math.min(segmentCount - 1, index));

    const value = this.minValue + index;
    this.updateVisually(value);
    this.valueChange(value);
  }

  updateVisually(value) {
    super.updateVisually(value);

    const index = value - this.minValue;
    const progress = (value - this.minValue) / ((this.maxValue - this.minValue) || 1);

    this.$sliderTrack.css("--progress", progress);
    this.$items.removeClass("active");
    this.$items.eq(index).addClass("active");
    this.$labelItems.removeClass("active");
    this.$labelItems.eq(index).addClass("active");
  }

  getRealValue() {
    return this.$items.eq(this.currentValue - this.minValue).data("value");
  }

  valueChange(value) {
    if (!value || value === this.currentValue) return;

    const phaseChange = 0.9 + Math.random() * 0.6;
    // const phaseChange = 1
    app.audio.play("audio/SliderAi_1.wav", 1, true, null, false, phaseChange);

    this.currentValue = value;
    this.currentRealValue = this.getRealValue();
    this.change();
  }

  emitValueChanged() {
    this.emit("userInputValueChanged", this.currentRealValue);
  }

  reset() {
    this.currentValue = this.initialValue;
    this.currentRealValue = this.getRealValue();
    this.updateVisually(this.currentValue);
    this.change();
  }

}
